<template lang="pug">
.informacao-agricola-container
    .header-section
        h3.section-title {{ $t('mensagens.territorio.information.titulo') }}
        p.section-description {{ $t('mensagens.territorio.information.descricao') }}
    
    .form-section
        .add-form
            el-select.cultivo-select(
                v-model='form.idCultura',
                :placeholder='$t("mensagens.territorio.information.cultivo")',
                filterable,
                clearable,
                size='medium'
            )
                el-option(
                    :value='item.id',
                    :label='item.nomeTraduzido',
                    :key='item.id',
                    v-for='(item, index) in cultivos'
                )
            el-button.add-button(
                @click='addInformation()',
                type='primary',
                icon='el-icon-plus',
                size='medium',
                :disabled='!form.idCultura'
            ) {{ $t('mensagens.territorio.information.adicionar') }}
    
    .list-section(v-if='options?.length > 0')
        .cultivo-item(
            v-for='(item, index) in options',
            :key='index'
        )
            .cultivo-info
                .cultivo-name {{ nameCultivo(item.cultivo) || nameCultivo(item.idCultura) }}
            .cultivo-actions
                el-button.remove-button(
                    @click='deleteInformation(index)',
                    type='text',
                    icon='el-icon-delete',
                    size='small'
                )
    
    .empty-state(v-else)
        .empty-icon
            i.el-icon-info
        .empty-text {{ $t('mensagens.territorio.information.nenhumCultivo') }}
</template>
<script>
export default {
    name: 'InformacaoAgricula',

    data() {
        return {
            form: { idCultura: '' }
        };
    },
    props: {
        options: {
            type: Array
        },
        cultivos: {
            type: Array,
            required: true
        }
    },

    methods: {
        addInformation() {
            const params = this.form;

            this.$emit('update', params);
            this.form = {
                idCultura: ''
            };
        },
        deleteInformation(index) {
            this.$emit('delete', index);
        },
        nameCultivo(id) {
            return this.cultivos.find(item => item.id === id)?.nomeTraduzido;
        }
    }
};
</script>
<style scoped lang="scss">
.informacao-agricola-container {
    .header-section {
        padding-top: 10px;
        margin-bottom: 16px;
        
        .section-title {
            font-size: 16px;
            font-weight: 600;
            color: #183b57;
            margin: 0 0 4px 0;
        }
        
        .section-description {
            font-size: 13px;
            color: #666;
            margin: 0;
            line-height: 1.4;
        }
    }
    
    .form-section {
        margin-bottom: 16px;
        
        .add-form {
            display: flex;
            gap: 12px;
            align-items: center;
            
            .cultivo-select {
                flex: 1;
                max-width: 300px;
            }
            
            .add-button {
                white-space: nowrap;
                min-width: 100px;
            }
        }
    }
    
    .list-section {
        .cultivo-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #f8f9fa;
            border: 1px solid #e9ecef;
            border-radius: 6px;
            padding: 12px 16px;
            margin-bottom: 8px;
            transition: all 0.2s ease;
            
            &:hover {
                background: #f1f3f4;
                border-color: #d1d5db;
            }
            
            .cultivo-info {
                flex: 1;
                
                .cultivo-name {
                    font-size: 14px;
                    font-weight: 500;
                    color: #183b57;
                    margin: 0;
                }
            }
            
            .cultivo-actions {
                margin-left: 12px;
                
                .remove-button {
                    color: #dc3545;
                    padding: 4px 8px;
                    
                    &:hover {
                        background: #f8d7da;
                        color: #721c24;
                    }
                }
            }
        }
    }
    
    .empty-state {
        text-align: center;
        padding: 24px 16px;
        background: #f8f9fa;
        border: 1px dashed #dee2e6;
        border-radius: 6px;
        
        .empty-icon {
            font-size: 24px;
            color: #6c757d;
            margin-bottom: 8px;
        }
        
        .empty-text {
            font-size: 14px;
            color: #6c757d;
            margin: 0;
        }
    }
}

// Responsividade
@media (max-width: 768px) {
    .informacao-agricola-container {
        .form-section .add-form {
            flex-direction: column;
            align-items: stretch;
            
            .cultivo-select {
                max-width: none;
            }
            
            .add-button {
                width: 100%;
            }
        }
    }
}
</style>
